import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

interface AvatarProps {
  src?: string;
  alt?: string;
  name?: string;
  size?: "small" | "medium" | "large";
}

const sizeClasses = {
  small: "w-10 h-10 text-sm",
  medium: "w-14 h-14 text-md",
  large: "w-20 h-20 text-lg",
};

const Avatar: React.FC<AvatarProps> = ({ src, alt, name, size = "medium" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const router = useNavigate();

  const { setUser, setIsAuthenticated, logout } = useStoreZustandUserAuth();

  const handleLogout = () => {
    router("/");
    logout();

    setUser(null);
    setIsAuthenticated(false);
  };

  return (
    <div className="relative">
      {/* Avatar */}
      <div
        className={`relative flex cursor-pointer items-center justify-center overflow-hidden rounded-full bg-gray-300 dark:bg-gray-700 ${sizeClasses[size]}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {src ? (
          <img src={src} alt={alt} className="h-full w-full object-cover" />
        ) : (
          <span className="font-semibold text-gray-600 dark:text-gray-300">
            {name ? name[0].toUpperCase() : "?"}
          </span>
        )}
      </div>

      {/* Popup (Dropdown) */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-40 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800">
          <button
            className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700"
            onClick={() => router("/my-data")}
          >
            ⚙ Minha conta
          </button>
          <button
            className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700"
            onClick={handleLogout}
          >
            ❌ Sair
          </button>
        </div>
      )}
    </div>
  );
};

export default Avatar;
